import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import useRegenerateInvoicePdf from "./useRegenerateInvoicePdf";
import usePrepareRegenerateInvoicePdf from "./usePrepareRegenerateInvoicePdf";
import { RegenerateInvoicePdfActionContext } from "./RegenerateInvoicePdfActionContext";

function useRegenerateInvoicePdfAction(modelConfig: any, index: any): any {
  const prepareRegenerateInvoicePdf = usePrepareRegenerateInvoicePdf();
  const prepareRegenerateInvoicePdfFunction = (id: any) => prepareRegenerateInvoicePdf(id);

  const onSuccess = () => {
    index();
  };

  const regenerate = useRegenerateInvoicePdf();
  const regenerateFunction = () => regenerate(onSuccess);

  const contextInstance = useContext(RegenerateInvoicePdfActionContext);
  const { showModal, setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "regenerate-invoice-pdf",
    onSubmit: () => regenerateFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <div>
        <p>{t("are_you_sure_you_want_to_regenerate_the_invoice_pdf?")}</p>
      </div>
    </CrudModuleFactoryModal>
  );

  return {
    prepareRegenerateInvoicePdfFunction,
    actionTemplate,
  };
}

export default useRegenerateInvoicePdfAction;